import React from "react"
import { Link } from "gatsby"

import TrustBadges from "./trustBadges"

import FacioLogoAlternative from "assets/logos/facio-alternative.svg"

import {
  footer,
  grid,
  badges,
  logo,
  help,
  downloadButtons,
  links,
  footerList,
  legal,
  socialMedia,
} from "./footer.module.css"

import PlayStore from "assets/google-play-badge.svg"
import AppStore from "assets/app-store-badge.svg"

import Instagram from "assets/icons/brands/instagram.svg"
import Facebook from "assets/icons/brands/facebook.svg"
import Linkedin from "assets/icons/brands/linkedin.svg"

const Footer = ({ hideTrustBadges }) => {
  return (
    <footer className={footer}>
      <div className="wrapper">
        <div className={grid}>
          <FacioLogoAlternative className={logo} />
          {!hideTrustBadges && (
            <div className={badges}>
              <TrustBadges dark center />
            </div>
          )}
          <div className={help}>
            <small>
              Facio.com.br pertence à Facio Pagamentos Ltda. (“Facio”), CNPJ 31.703.183/0001-35, com
              sede na Rua Claudio Soares, 72, Pinheiros, São Paulo, SP, CEP: 05422-030
            </small>
            <h4>Aplicativo Facio</h4>
            <p className={downloadButtons}>
              <a href="https://play.google.com/store/apps/details?id=com.facio.facio_app">
                <PlayStore alt="Download na play store" />
              </a>
              <a href="https://apps.apple.com/br/app/facio/id1487549868">
                <AppStore alt="Download na app store" />
              </a>
            </p>
            <div>
              <p>
                <strong> Precisa de ajuda?</strong>
              </p>
              <p>Chama a gente no Whatsapp</p>
              <p>
                <a href="https://wa.me/551140405513">(11) 4040-5513</a>
              </p>
            </div>
          </div>

          <div className={links}>
            <div>
              <h4>Explore</h4>
              <ul className={footerList}>
                <li>
                  <Link to="/">Início</Link>
                </li>
                <li>
                  <Link to="https://ajuda.facio.com">Central de ajuda</Link>
                </li>
                <li>
                  <Link to="/sobre-a-facio">Sobre a Facio</Link>
                </li>
                <li>
                  <Link to="/imprensa">Imprensa</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Transparência</h4>
              <ul className={footerList}>
                <li>
                  <Link to="/seguranca">Segurança</Link>
                </li>
                <li>
                  <Link to="/contratos/politica-de-privacidade">Política de privacidade</Link>
                </li>
                <li>
                  <Link to="/contratos/programa-de-indicacoes">Regulamento do programa de indicações</Link>
                </li>
                <li>
                  <Link to="/contratos/antecipacao-de-salario">
                    Contrato de antecipação de salário
                  </Link>
                </li>
              </ul>
              <h4>Redes</h4>
              <ul className={[footerList, socialMedia].join(" ")}>
                <li>
                  <a href="https://instagram.com/antecipafacio">
                    <Instagram />
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/people/Facio-ajudinha-financeira/61550543528026/">
                    <Facebook />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/antecipafacio">
                    <Linkedin />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
